/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Details = {
    type: 'array',
    contains: {
        type: 'Detail',
    },
};